import React from 'react'
import RMIcon from './RMIcon';
import PHPIcon from './PHPIcon'

const CurrencySymbol: { [key: string]: React.FC } = {
    MYR: RMIcon,
    PHP: PHPIcon,
  }

 export const renderIcon = (iconKey: string | undefined) => {
    if (iconKey && CurrencySymbol[iconKey]) {
      const IconComponent = CurrencySymbol[iconKey];
      return <IconComponent />;
    }
    return null;
  };